export default __webpack_public_path__ + "static/media/AWS_S3.a7bd1072.svg";